import PropTypes from "prop-types"

export const DescriptionsList = ({ children }) => {
  return (
    <dl className="grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-x-16">
      {children}
    </dl>
  )
}

DescriptionsList.propTypes = {
  children: PropTypes.node,
}
